import Decimal from 'decimal.js';
import * as yup from 'yup';

import { toBN } from '@utils/formaters.utils';

import { ErrorMessages } from '@constants/common/messages.constants';
import { WALLET_ADDRESS_REGEX } from '@constants/common/regex.constants';

export const amountYup = (balance: Decimal) =>
  yup
    .string()
    .typeError(ErrorMessages.InvalidType)
    .required(ErrorMessages.Required)
    .test(
      'non-zero',
      ErrorMessages.NonZeroAmount,
      (value) => !toBN(value).equals(0),
    )
    .test(
      'max',
      ErrorMessages.Max.replace('[max]', balance.toString()),
      (value) => toBN(value).lte(balance),
    );

export const priceYup = (max: number) =>
  yup
    .string()
    .typeError(ErrorMessages.InvalidType)
    .required(ErrorMessages.Required)
    .test(
      'non-zero',
      ErrorMessages.NonZeroAmount,
      (value) => !toBN(value).equals(0),
    )
    .test('max', ErrorMessages.Max.replace('[max]', max.toString()), (value) =>
      toBN(value).lte(max),
    );

export const nftAmountForPurchaseYup = ({
  balance,
  nftAmount,
  price,
  decimal,
}: {
  balance: Decimal;
  nftAmount: Decimal;
  price: Decimal;
  decimal: number;
}) =>
  yup
    .string()
    .typeError(ErrorMessages.InvalidType)
    .required(ErrorMessages.Required)
    .test(
      'non-zero',
      ErrorMessages.NonZeroAmount,
      (value) => !toBN(value).equals(0),
    )
    .test(
      'max',
      ErrorMessages.MaxNftAmount.replace('[max]', nftAmount.toString()),
      (value) => toBN(value).lte(nftAmount),
    )
    .test(
      'max',
      ErrorMessages.InsufficientBalanceMax.replace(
        '[max]',
        toBN(balance, decimal).toString(),
      ),
      (value) => toBN(value).times(price).lte(balance),
    );

export const addressYup = () =>
  yup
    .string()
    .typeError(ErrorMessages.InvalidType)
    .required(ErrorMessages.Required)
    .matches(WALLET_ADDRESS_REGEX, ErrorMessages.InvalidEvmAddressError);
